import { render, staticRenderFns } from "./BooksLatestList.vue?vue&type=template&id=2ddf4403"
import script from "./BooksLatestList.vue?vue&type=script&lang=js"
export * from "./BooksLatestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports